/**
 * Navigation-related handlers
 */

import type { NavigateFunction } from 'react-router-dom'
import type { QueryClient } from '@tanstack/react-query'
import type { dia } from '@joint/core'
import type { EditorModalState } from '../types'

export function handleBackToProjectsFn(params: {
  queryClient: QueryClient
  graph: dia.Graph | null
  handleSave: () => void
  navigate: NavigateFunction
  urlProjectId: string | undefined
}) {
  const { queryClient, graph, handleSave, navigate, urlProjectId } = params

  // Invalidate projects cache to ensure fresh data on dashboard
  queryClient.invalidateQueries({ queryKey: ['projects', 'list'] })

  // Check if there are unsaved changes
  if (graph && graph.getCells().length > 0) {
    const confirmed = window.confirm(
      '\uD504\uB85C\uC81D\uD2B8\uB97C \uB098\uAC00\uAE30 \uC804\uC5D0 \uC800\uC7A5\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?\n\n\uC800\uC7A5\uD558\uC9C0 \uC54A\uC740 \uBCC0\uACBD\uC0AC\uD56D\uC740 \uC190\uC2E4\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.'
    )

    if (confirmed) {
      // Save before leaving
      handleSave()
      navigate(`/project/${urlProjectId}/map-editor`)
    } else {
      navigate(`/project/${urlProjectId}/map-editor`)
    }
  } else {
    navigate(`/project/${urlProjectId}/map-editor`)
  }
}

export function handleSaveModalConfirmFn(params: {
  autoNavigate: boolean
  setModalState: React.Dispatch<React.SetStateAction<EditorModalState>>
  setAutoNavigate: React.Dispatch<React.SetStateAction<boolean>>
  navigate: NavigateFunction
  urlProjectId: string | undefined
}) {
  const { autoNavigate, setModalState, setAutoNavigate, navigate, urlProjectId } = params

  const shouldNavigate = autoNavigate
  setModalState((prev) => ({ ...prev, save: false }))
  setAutoNavigate(false)
  if (shouldNavigate) {
    navigate(`/project/${urlProjectId}/map-editor`)
  }
}
